<div class="card">
  <div class="card-header">Local Profiles</div>
  <div class="card-body" style="min-height: 700px;" [loadingOverlay]="isLoading">
    @if (!isLoading) {
      @if (shouldLockScreen) {
        <ng-container *ngTemplateOutlet="lockScreen"></ng-container>
      } @else {
        <ng-container *ngTemplateOutlet="profiles"></ng-container>
      }
    }
  </div>
</div>

<ng-template #profiles>
  <app-components-shared-local-profiles
    [customer]="customer"
    [canAddLocalProfile]="true"
    [showSubscriptions]="true"
    [allowValidationAndAugmentationOrdering]="true"
    [createValidationAndAugmentationForNewLocalProfiles]="true"
    [showResearchMinimum]="true">
  </app-components-shared-local-profiles>
</ng-template>

<ng-template #lockScreen>
  <div class="alert alert-warning mb-4" role="alert">
    <strong>Notice:</strong> The onboarding instructions—whether from SEO or Business Profile Management—will be used during the initial <em>Business Profile Validation and Augmentation Task</em>. Local profiles cannot be modified until this task is completed.
  </div>
  @if (editingInitialization) {
    <ng-container *ngTemplateOutlet="editInitialization"></ng-container>
  } @else if (localProfileRequirements.HasOpenInitialization) {
    <ng-container *ngTemplateOutlet="initialization"></ng-container>
  }
</ng-template>

<ng-template #initialization>
  <div  class="border rounded p-3 bg-light">
    <h6 class="fw-bold text-secondary mb-3">Onboarding Instructions
      @if (canEditInitialization) {
        <i class="ms-1 fas fa-edit text-primary cursor-pointer" (click)="toggleEditingInitialization(true)"></i>
      }
    </h6>

    <div class="d-flex mb-2">
      <div class="text-muted" style="min-width: 200px;">Number of Local Profiles</div>
      <div>{{ localProfileRequirements.RequiredLocalProfiles }}</div>
    </div>

    <div class="d-flex mb-2">
      <div class="text-muted" style="min-width: 200px;">Number of Subscriptions</div>
      <div>{{ localProfileRequirements.RequiredSubscriptions }}</div>
    </div>

    <div class="d-flex">
      <div class="text-muted" style="min-width: 200px;">Note to Fulfillment</div>
      <div style="white-space: pre-wrap;">{{ localProfileRequirements.Note || 'N/A' }}</div>
    </div>
  </div>
</ng-template>

<ng-template #editInitialization>
  <div class="border rounded p-3 bg-light">
    <h6 class="fw-bold text-secondary mb-3">Onboarding Instructions</h6>
    <app-components-shared-local-profile-initialization [customer]="customer">
    </app-components-shared-local-profile-initialization>
    <div class="text-end mt-3">
      <button (click)="toggleEditingInitialization(false)" type="submit" class="btn btn-link" style="margin-left:5px;">Cancel</button>
      <button (click)="saveInitilization()" type="submit" class="btn btn-success" style="margin-left:5px;"><i class="fa fa-save"></i>Save</button>
    </div>
  </div>
</ng-template>